// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2J3sU","errorLogs":"EditorFooter_errorLogs__dLcsQ"};